import React, { useState, useRef, useEffect } from "react"

export const TooltipLight = ({
  content,
  extra_bottom_distance = 17,
  is_right,
}) => {
  const tooltip_ref = useRef(null)
  const [tooltip_bottom_dist, set_tooltip_bottom_dist] = useState(60)
  useEffect(() => {
    set_tooltip_bottom_dist(
      tooltip_ref.current.clientHeight / 2 - extra_bottom_distance
    )
  }, []) //eslint-disable-line
  return (
    <div
      style={{
        bottom: -tooltip_bottom_dist,
      }}
      className={`tooltip-light${!!is_right ? " is-right" : ""}`}
      ref={tooltip_ref}
    >
      {content}
    </div>
  )
}
